import { useCallback } from 'react';
import Order from '../components/Order';
import { useNavigate } from 'react-router-dom';
import Box from '../components/Box';
import { RegisterOptions, useForm } from 'react-hook-form';
import Form from '../components/Form';
import {
  changeUsernameCompletionMessage,
  max,
  requiredByUserNameMessage,
} from '../../../message';
import FormBlockItem from '../../../components/common/FormBlockItem';
import {
  useGetCurrentUserQuery,
  usePutUserNameMutation,
} from '../../../api/userApi';
import HeaderLayout from '../../../components/HeaderLayout';
import { logger } from '../../../services/logger';

const userNameValidation: RegisterOptions = {
  required: requiredByUserNameMessage,
  maxLength: {
    value: 255,
    message: max('名前', 255),
  },
};

function ChangeUsername() {
  const name = useCurrentName();
  const { register, errors, onSubmit, onCancel } = useFormProps();

  return (
    <HeaderLayout title="マイページ">
      <Form onSubmit={onSubmit} onCancel={onCancel}>
        <Box title="名前を変更" isChange={true}>
          <Order>新しい名前を入力してください。</Order>
          <FormBlockItem
            label="現在の名前"
            name="current-name"
            defaultValue={name}
            disabled
          />
          <FormBlockItem
            label="新しい名前"
            autoFocus
            {...register('userName', userNameValidation)}
            error={
              errors.userName?.message
                ? String(errors.userName?.message)
                : undefined
            }
          />
        </Box>
      </Form>
    </HeaderLayout>
  );
}

export default ChangeUsername;

function useCurrentName() {
  const { data } = useGetCurrentUserQuery();
  return data?.userName;
}

function useFormProps() {
  const navigate = useNavigate();
  const [putUserName] = usePutUserNameMutation();
  const methods = useForm({ mode: 'onBlur' });

  const onSubmit = methods.handleSubmit(async (data: { userName?: string }) => {
    await putUserName({ userName: data.userName ?? '' })
      .unwrap()
      .then(() => {
        // マイページ画面に成功メッセージ付きでリダイレクトする
        navigate(
          `/mypage?success=${encodeURIComponent(
            changeUsernameCompletionMessage
          )}`
        );
      })
      .catch(logger.error);
  });

  const onCancel = useCallback(() => {
    navigate('..');
  }, []);

  return {
    register: methods.register,
    errors: methods.formState.errors,
    onSubmit,
    onCancel,
  };
}
